/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const BlockIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g>
      <circle cx="12" cy="12" r="11.5" />
      <path d="M12,4.333 C7.766,4.333 4.333,7.766 4.333,12 C4.333,13.598 4.822,15.08 5.659,16.308 L16.309,5.659 C15.08,4.823 13.598,4.333 12,4.333 Z" />
      <path d="M7.691,18.341 C8.92,19.177 10.402,19.667 12,19.667 C16.233,19.667 19.667,16.235 19.667,12 C19.667,10.403 19.177,8.92 18.341,7.691 L7.691,18.341 Z" />
    </g>
  </svg>
);

export default BlockIcon;
